<script>
import BaseSubNav from "@/components/ui/BaseSubNav.vue";
import doctorService from "@/services/doctor";

export default {
  name: "Contracts",
  components: {
    BaseSubNav,
  },
  data() {
    return {
      doctors: [],
      isLoading: false,
    };
  },
  async created() {
    await this.getDoctors();
  },
  methods: {
    async getDoctors() {
      this.isLoading = true;
      try {
        this.doctors = await doctorService.getDoctors();
      } catch (error) {
        console.error("Error al cargar doctores:", error);
        this.doctors = [];
      } finally {
        this.isLoading = false;
      }
    },
    goToDoctorServices(doctor) {
      this.$router.push({
        name: "doctor-services",
        params: { doctorId: doctor._id },
        query: { doctor: JSON.stringify(doctor) },
      });
    },
  },
};
</script>

<template lang="pug">
  div
    BaseSubNav
      template(#title)
        | Contratos
    
    .doctors-section(v-if="!isLoading")
      .doctors-table
        table
          thead
            tr
              th Nombre
              th Email
              th Especialidades
          tbody
            tr.clickable(v-for="doctor in doctors" :key="doctor._id" @click="goToDoctorServices(doctor)")
              td {{ doctor.firstName }} {{ doctor.lastName }}
              td {{ doctor.email || '-' }}
              td {{ doctor.doctor.medicalSpecialties && doctor.doctor.medicalSpecialties.length > 0 ? doctor.doctor.medicalSpecialties.map(s => s.name).join(', ') : '-' }}
    
    .loading(v-if="isLoading")
      p Cargando doctores...
    
    .error(v-if="!isLoading && doctors.length === 0")
      p No se encontraron doctores.
</template>

<style lang="scss" scoped>
h3 {
  color: #040055;
  margin: 2rem 0 1rem 0;
  font-size: 1.3rem;
  padding: 0 2rem;
}

.doctors-section {
  margin-top: 2rem;
}

.doctors-table {
  margin-top: 1rem;
  overflow-x: auto;
  background: white;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.1);
  border-radius: 10px;

  table {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
  }

  .clickable {
    cursor: pointer;
    transition: background-color 0.2s ease;

    &:hover {
      background-color: #f8f9fa;
    }
  }
}

.loading,
.error {
  text-align: center;
  padding: 2rem;
  color: #666;
  font-style: italic;
}

.error {
  color: #d32f2f;
}
</style>
